import Actions                  from 'Redux/Actions';
import { EventCategoryRepository }  from 'Domain/Repositories';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { message }              from 'antd';

export const updateEventCategoryEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.updateEventCategoryRequest.type),
    mergeMap(action => from(EventCategoryRepository.update(action.payload.id, action.payload.formData))
      .pipe(
        mergeMap((eventCategory) => {
          message.success('Die Speicherung der Event Kategorie erfolgreich.');

          return from([
            Actions.updateEventCategorySuccess({ eventCategory }),
          ]);
        }),
        catchError(error => {
          return from([
            Actions.updateEventCategoryFailure({ error })
          ]);
        })
      )
    ),
  );
};
